import React from 'react';
import { CrossIconSvg } from '../../assets/svg';
import './style.scss'

interface ICustomModal {
  show: boolean;
  closeBtnVis?: boolean;
  handleClose: () => void;
  children: any;
  clx?: any;
}

const CustomModal: React.FC<ICustomModal> = (props) => {
  const { show, closeBtnVis = true, handleClose, children, clx = "" } = props;
  return (
    <>
      {show && (
       <>
        <div className={`custom-modal-wrapper ${clx}`}>
          <section className='custom-modal-section'>
            {closeBtnVis &&
              <div className="close-btn-icon" onClick={handleClose}>
                <CrossIconSvg/>
              </div>}
            {children}
          </section>
        </div> 
        <div className='custom-modal-backdrop'></div>
       </>  
      )}
    </>
  );
};

export default CustomModal;
